import { UNIT, BLACK } from "../../constants/configuration";

export const FORM_GAP = UNIT * 0.25;

export const styles = {
  btnStyle: {
    borderRadius: UNIT * 2,
    fontSize: UNIT * 0.75,
    fontFamily: "sans-serif",
    height: UNIT * 2.1875,
    fontWeight: 600,
  },
  broderStyle: {
    border: "1px solid #6A6A6A",
    margin: `${UNIT * 0.875}px 0px`,
  },
  forgetPasswordStyle: {
    fontSize: UNIT * 0.75,
    color: BLACK,
    textDecoration: "underline",
    fontWeight: "500",
  },
  closeButton: {
    opacity: 1,
    fontWeight: 300,
    fontSize: "xx-large",
  },
  socialButtonSx: {
    display: "flex",
    padding: "12px 16px",
    justifyContent: "center",
    alignItems: "center",
    gap: "16px",
    flex: "1 0 0",
    borderRadius: "8px",
    pointerEvents: "none",
    "& > .MuiBox-root": {
      marginBottom: 0,
      padding: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
  },
  socialButtonLabel: {
    fontStyle: "normal",
    lineHeight: "24px",
    letterSpacing: "-0.32px",
    textTransform: "uppercase",
  },
  dividerText: {
    color: "#979897",
    fontWeight: 500,
    px: 4,
  },
  forgetPasswordSx: {
    color: "primary.main",
    cursor: "pointer",
    fontSize: "12px",
    fontWeight: 500,
  }
};

export default styles;
